import React from 'react'
import Layout from '../../Layout/Layout'

import { Link } from "react-router-dom";
import ai1 from '../../images/ai1.PNG'

const ai_programs_evaluation = () => {
  return (
      <Layout>
        <div className='uk-container'>
            <div>
                <h2 className='light uk-text-bold uk-margin-xlarge-top'>AI Programs/Evaluation</h2>
                 <h3 className='light uk-text-bold '>Intel Africa AI Community Outreach Outreach</h3>
                
                </div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Intel AI Community Outreach  2.0 initiative, for which
                         Moolu Venture Lab served as an Independent Evaluator, was a collaborative 
                         program supported by Intel and AfriLabs. The primary goal of the program 
                         was to accelerate the development of the African Artificial Intelligence
                          (AI) ecosystem by scouting and validating high-potential, AI-focused
                           projects across the African Union member states
</p>

                <p className='light'>Moolu Venture Lab's role was to ensure an unbiased and
                     rigorous selection process, evaluating projects based on technical
                      feasibility, community impact, and potential for sustainable growth</p>
               </div>

                <div className='uk-width-1-2@s'>
                    <img src= {ai1} />
               </div>
            </div>

            <div className='uk-grid'>
                <div className='uk-width-1-2@s'>
                  <p className='light'>The evaluation process by Moolu Venture Lab employed a robust methodology,
                     including a customized, detailed Assessment Rubric to score all applications
                      consistently against predefined criteria. Key challenges noted in the evaluation
                       included low quality of application submissions and poor documentation of promising 
                       ideas, which led to a recommendation for the creation of a "development pipeline" 
                       for coaching and refinement. Ultimately, this independent evaluation was crucial in 
                       identifying the most promising projects that could truly contribute to AI-driven 
                       innovation across the continent.</p>
                </div>

                 <div className='uk-width-1-2@s'>

                </div>
            </div>





        </div>
        </Layout>
  )
}

export default ai_programs_evaluation